module.exports = __webpack_public_path__ + "static/media/botoes.f1a6c69a.gif";